import React from 'react'
import { Link } from 'react-router'
import { DataCardHeader } from '../data-card/data-card-parts'
import { connect } from 'react-redux'
import { setCurrentFilter } from '../../actions/areas'

const OpenIssueHeader = ({
  areaId,
  servicingId,
  workOrderId,
  openIssueCount,
  className = ''
}) => (
  <Link to={`work-orders/${workOrderId}/details/areas/${servicingId}/${areaId}/issues`}>
    <DataCardHeader
      text={`${openIssueCount} Open ${openIssueCount > 1 ? 'Issues' : 'Issue'}`}
      className={className}
    />
  </Link>
)

export default OpenIssueHeader



// WEBPACK FOOTER //
// ./src/components/issues/open-issue-header.js